var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column h-100" },
    [
      _setup.userExists
        ? _c(
            "div",
            { staticClass: "main-container d-flex flex-column h-100" },
            [
              _c(_setup.AjaxLoading),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex h-100 overflow-auto flex-column" },
                [
                  _c(_setup.Navigation),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "main-content flex-grow-1" },
                    [_c("router-view")],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(_setup.Support),
              _vm._v(" "),
              _c(_setup.UserProfileOffcanvas),
              _vm._v(" "),
              _c(_setup.Modals),
            ],
            1
          )
        : !_setup.userExists && _setup.tokenExists()
        ? _c("div", { staticClass: "ajax-spinner" }, [
            _c("span", { staticClass: "ajax-spinner-icon" }),
          ])
        : !_setup.userExists
        ? _c(_setup.LoginForm)
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.Toasts),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }